import { EventDispatcher, Vector2, Vector3, Plane } from 'three';
import { Utils } from '../core/utils.js';
import { EVENT_MOVED, EVENT_CHANGED,EVENT_DELETED } from '../core/events.js';

export class Icon extends EventDispatcher {
    /**
     *  create Icon using icon as data and (x,y) position 
     *  
     * */
    constructor(icon, x, y, id) {
        super();

        this.id = id || Utils.guide();

        this.__icon = icon;
        this.__x = x || 0;
        this.__y = y || 0;

        this.__width = icon.width || 0;
        this.__height = icon.height || 0;

        this.__name = icon.name || 'icon';
        this.__url = icon.url;

        this.__rotation = icon.rotation || 0;
        this.__scale = icon.scale || 1;

        this.__location = new Vector2(this.__x,this.__y);

    }

    set location(vec2){
        this.__location = vec2;
    }

    get location(){
        return this.__location;
    }

    set rotation(deg){
        this.__rotation = deg;
    }

    get rotation(){
        return this.__rotation;
    }


    set scale(vec2){
        this.__scale = vec2;
    }

    get scale(){
        return this.__scale;
    }

    get icon(){
        return this.__icon;
    }

    get x(){
        return this.__location.x;
    }

    get y(){
        return this.__location.y;
    }

    get width(){
        return this.__width;
    }

    get height(){
        return this.__height;
    }

    get name(){
        return this.__name;
    }

    get url(){
        return this.__url;
    }

    metadata(){
        let json = {};
        json.id = this.id;
        json.name = this.name;
        json.url = this.url;
        json.location = this.location.toArray();
        json.x = this.x;
        json.y = this.y;
        json.width = this.width;
        json.height = this.height;
        json.rotation = this.rotation;
        json.scale = this.scale;
        return json;
    }

   

}